"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionOverlay = exports.getPermissionMessage = exports.getPermissionIcon = exports.mergePermissions = exports.PermissionMode = void 0;

var react_1 = __importDefault(require("react"));

var icons_1 = require("../icons");

var Button_1 = require("./ant/Button");

var styled_1 = require("./styled");

var Block_1 = require("./styled/Block");

var Blur_1 = require("./styled/Blur");

var theme_1 = require("./theme");

var typography_1 = require("./typography");

var useOpenSettings_1 = require("./useOpenSettings");

var PermissionMode;

(function (PermissionMode) {
  PermissionMode["Authorized"] = "authorized";
  PermissionMode["Unavailable"] = "unavailable";
  PermissionMode["NotDetermined"] = "not-determined";
  PermissionMode["Denied"] = "denied";
  PermissionMode["Restricted"] = "restricted";
})(PermissionMode = exports.PermissionMode || (exports.PermissionMode = {}));

function mergePermissions() {
  for (var _len = arguments.length, permissions = new Array(_len), _key = 0; _key < _len; _key++) {
    permissions[_key] = arguments[_key];
  }

  return permissions.reduce(function (acc, permission) {
    return permission !== PermissionMode.Authorized ? permission : acc;
  }, PermissionMode.Authorized);
}

exports.mergePermissions = mergePermissions;

function getPermissionIcon(mode) {
  switch (mode) {
    case PermissionMode.Restricted:
      return react_1.default.createElement(icons_1.ShieldAlert, null);

    case PermissionMode.Unavailable:
      return react_1.default.createElement(icons_1.WarningCircledOutline, null);

    default:
      return react_1.default.createElement(icons_1.QuestionMarkCircle, null);
  }
}

exports.getPermissionIcon = getPermissionIcon;

function getPermissionMessage(mode, requesting) {
  switch (mode) {
    case PermissionMode.Authorized:
      return {
        title: '',
        description: ''
      };

    case PermissionMode.NotDetermined:
      return {
        title: 'Allow Access',
        description: "We need access to your ".concat(requesting, " to continue.")
      };

    case PermissionMode.Denied:
      return {
        title: 'Allow Access',
        description: "Open Settings to allow us access to your ".concat(requesting, ".")
      };

    case PermissionMode.Restricted:
      return {
        title: "Can't Allow Access",
        description: "We need access to your ".concat(requesting, ", but parental controls on your device are preventing this.")
      };

    case PermissionMode.Unavailable:
      return {
        title: 'Device not Available',
        description: "We need access to your ".concat(requesting, ", but it appears one of those is not available.")
      };
  }
}

exports.getPermissionMessage = getPermissionMessage;

function PermissionOverlay(_ref) {
  var _this = this;

  var permissionMode = _ref.permissionMode,
      onRequest = _ref.onRequest,
      requesting = _ref.requesting,
      hideBlur = _ref.hideBlur;
  var openSettings = (0, useOpenSettings_1.useOpenSettings)();

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      loading = _react_1$default$useS2[0],
      setLoading = _react_1$default$useS2[1];

  var theme = (0, theme_1.useTheme)();

  if (permissionMode !== PermissionMode.Authorized) {
    var canRequest = permissionMode === PermissionMode.NotDetermined;
    var canOpenSettings = permissionMode === PermissionMode.Denied;
    var icon = getPermissionIcon(permissionMode);

    var _getPermissionMessage = getPermissionMessage(permissionMode, requesting),
        title = _getPermissionMessage.title,
        description = _getPermissionMessage.description;

    return react_1.default.createElement(react_1.default.Fragment, null, hideBlur ? null : react_1.default.createElement(Blur_1.Blur, {
      forceDark: true
    }), react_1.default.createElement(Container, null, react_1.default.cloneElement(icon, {
      width: (0, theme_1.getSize)(theme, '@size-xl'),
      height: (0, theme_1.getSize)(theme, '@size-xl'),
      color: 'white'
    }), react_1.default.createElement(Block_1.Block, {
      marginTop: '@size-m',
      marginBottom: '@size-xs'
    }, react_1.default.createElement(typography_1.H2, {
      style: {
        color: 'white',
        textAlign: 'center'
      },
      isBlock: false
    }, title)), react_1.default.createElement(typography_1.BodyLarge, {
      children: description,
      style: {
        color: 'white',
        textAlign: 'center'
      }
    }), canOpenSettings ? react_1.default.createElement(Block_1.Block, {
      marginTop: '@size-s'
    }, react_1.default.createElement(Button_1.Button, {
      type: 'link',
      onClick: openSettings,
      children: 'Open Settings'
    })) : canRequest ? react_1.default.createElement(Block_1.Block, {
      marginTop: '@size-s'
    }, react_1.default.createElement(Button_1.Button, {
      loading: loading,
      type: 'link',
      onClick: function onClick() {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setLoading(true);
                  _context.prev = 1;
                  _context.next = 4;
                  return onRequest();

                case 4:
                  _context.prev = 4;
                  setLoading(false);
                  return _context.finish(4);

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1,, 4, 7]]);
        }));
      },
      children: 'Grant Access and Continue'
    })) : null));
  } else return null;
}

exports.PermissionOverlay = PermissionOverlay;
var Container = (0, styled_1.styledContainer)(_templateObject());